import { FC } from 'react';

import Page from '@/components/Page.tsx';

const SearchPage: FC = () => {
    // eslint-disable-next-line i18next/no-literal-string
    return <Page fullScreen>Search Page</Page>;
};

export default SearchPage;
